import styled from 'styled-components';

import { styledReset, styledTypography } from '@pkg/primitives';

export const PrimitiveInputNumber = styled.input.attrs({ type: 'number' })`
    ${styledReset.inputNumber};
    ${styledTypography.allianceBase};
    font-variant-numeric: tabular-nums;
    text-align: center;

    &:disabled {
        cursor: not-allowed;
    }
`;
